<template lang="pug">
div.ng-result
  header.short
    .topbar.info-top
      .d-flex.info-content.align-items-center
        template(v-if="whiteLabel")
          router-link.back(to="/prematch")
            i.fas.fa-long-arrow-alt-left
            span {{ $t("ui.back") }}
        .logo
          img(:src="'/images/icon-sport-svg/' + getImage(sportsType)")
          span {{ title }}
        .nav-info.flex-fill
        .nav-info
  .info-wrapper
    .info-tablewrap.magicZ
      .table-responsive
        template(v-if="racingList.includes(parseInt(sportsType))")
          .tab-content(v-if="racingList1.includes(parseInt(sportsType))")
            table
              thead
                tr.text-white.result-bg
                  th(scope='col') {{ $t('ui.date') }}
                  th(scope='col') 1st
                  th(scope='col') 2nd
                  th(scope='col') 3rd
                  th(scope='col') {{ $tc("m.BT_OU", 2) }}
                  th(scope='col') {{ $tc("m.BT_OE", 2) }}
              tbody
                tr(v-for="(item, key, index) in schedule.EFResult")
                  td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                  td(data-label="1st") 
                    span(v-if="item.dog1 == 1") {{ item.dog1_name }}
                    span(v-if="item.dog2 == 1") {{ item.dog2_name }}
                    span(v-if="item.dog3 == 1") {{ item.dog3_name }}
                    span(v-if="item.dog4 == 1") {{ item.dog4_name }}
                    span(v-if="item.dog5 == 1") {{ item.dog5_name }}
                    span(v-if="item.dog6 == 1") {{ item.dog6_name }}
                  td(data-label="2nd")
                    span(v-if="item.dog1 == 2") {{ item.dog1_name }}
                    span(v-if="item.dog2 == 2") {{ item.dog2_name }}
                    span(v-if="item.dog3 == 2") {{ item.dog3_name }}
                    span(v-if="item.dog4 == 2") {{ item.dog4_name }}
                    span(v-if="item.dog5 == 2") {{ item.dog5_name }}
                    span(v-if="item.dog6 == 2") {{ item.dog6_name }}
                  td(data-label="3rd")
                    span(v-if="item.dog1 == 3") {{ item.dog1_name }}
                    span(v-if="item.dog2 == 3") {{ item.dog2_name }}
                    span(v-if="item.dog3 == 3") {{ item.dog3_name }}
                    span(v-if="item.dog4 == 3") {{ item.dog4_name }}
                    span(v-if="item.dog5 == 3") {{ item.dog5_name }}
                    span(v-if="item.dog6 == 3") {{ item.dog6_name }}
                  td(:data-label='$tc("m.BT_OU", 2)')
                    .digits.rounded-circle.mx-auto.text-white.bg-danger(v-if="item.dog4 == 1 || item.dog5 == 1 || item.dog6 == 1") {{ $t('m.LOT_OVER') }}
                    .digits.rounded-circle.mx-auto.text-white.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                  td(:data-label='$tc("m.BT_OE", 2)')
                    .digits.rounded-circle.mx-auto.text-white.bg-danger(v-if="item.dog1 == 1 || item.dog3 == 1 || item.dog5 == 1") {{ $t('m.LOT_ODD') }}
                    .digits.rounded-circle.mx-auto.text-white.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
          .tab-content(v-if="racingList2.includes(parseInt(sportsType))")
            table
              thead
                tr.text-white.result-bg
                  th(scope='col') {{ $t('ui.date') }}
                  th(scope='col') 1st
                  th(scope='col') 2nd
                  th(scope='col') 3rd
                  th(scope='col') 4th
                  th(scope='col') 5th
                  th(scope='col') {{ $t('ui.score') }}
                  th(scope='col') {{ $t('ui.yellow') }} {{ $t('m.GC_OU') }}
                  th(scope='col') {{ $t('ui.blue') }} {{ $t('m.GC_OU') }}
                  th(scope='col') {{ $t('ui.yellow') }} {{ $t('m.GC_OE') }}
                  th(scope='col') {{ $t('ui.blue') }} {{ $t('m.GC_OE') }}
              tbody
                tr(v-for="(item, key, index) in schedule.EFResult")
                  td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                  td(data-label="1st") 
                    span.digits.rounded-circle.mx-auto.text-white.ball-blue(v-if="item.ball_1 == 'B'") B
                    span.digits.rounded-circle.mx-auto.ball-yellow(v-else) Y
                  td(data-label="2nd") 
                    span.digits.rounded-circle.mx-auto.text-white.ball-blue(v-if="item.ball_2 == 'B'") B
                    span.digits.rounded-circle.mx-auto.ball-yellow(v-else) Y
                  td(data-label="3rd") 
                    span.digits.rounded-circle.mx-auto.text-white.ball-blue(v-if="item.ball_3 == 'B'") B
                    span.digits.rounded-circle.mx-auto.ball-yellow(v-else) Y
                  td(data-label="4th") 
                    span.digits.rounded-circle.mx-auto.text-white.ball-blue(v-if="item.ball_4 == 'B'") B
                    span.digits.rounded-circle.mx-auto.ball-yellow(v-else) Y
                  td(data-label="5th") 
                    span.digits.rounded-circle.mx-auto.text-white.ball-blue(v-if="item.ball_5 == 'B'") B
                    span.digits.rounded-circle.mx-auto.ball-yellow(v-else) Y
                  td(:data-label="$t('ui.score')")
                    span {{ item.home_score }}-{{ item.away_score }}
                  td(:data-label="$t('ui.yellow') + ' ' + $t('m.GC_OU')")
                    span.digits.rounded-circle.mx-auto.text-white.ball-over(v-if="item.home_score>item.away_score") {{ $t('m.LOT_OVER') }}
                    span.digits.rounded-circle.mx-auto.text-white.ball-under(v-else) {{ $t('m.LOT_UNDER') }}
                  td(:data-label="$t('ui.blue') + ' ' + $t('m.GC_OU')")
                    span.digits.rounded-circle.mx-auto.text-white.ball-over(v-if="item.home_score<item.away_score") {{ $t('m.LOT_OVER') }}
                    span.digits.rounded-circle.mx-auto.text-white.ball-under(v-else) {{ $t('m.LOT_UNDER') }}
                  td(:data-label="$t('ui.yellow') + ' ' + $t('m.GC_OE')")
                    span.digits.rounded-circle.mx-auto.text-white.ball-odd(v-if="item.home_score%2!=0") {{ $t('m.LOT_ODD') }}
                    span.digits.rounded-circle.mx-auto.text-white.ball-even(v-else) {{ $t('m.LOT_EVEN') }}
                  td(:data-label="$t('ui.blue') + ' ' + $t('m.GC_OE')")
                    span.digits.rounded-circle.mx-auto.text-white.ball-odd(v-if="item.away_score%2!=0") {{ $t('m.LOT_ODD') }}
                    span.digits.rounded-circle.mx-auto.text-white.ball-even(v-else) {{ $t('m.LOT_EVEN') }}
          .tab-content(v-if="racingList3.includes(parseInt(sportsType))")
            table
              thead
                tr.text-white.result-bg
                  th(scope='col') {{ $t('ui.date') }}
                  th(scope='col') {{ $t('ui.team') }}
                  th(scope='col') {{ $t('ui.winner') }}
                  th(scope='col') {{ $tc("m.BT_OU", 2) }}
                  th(scope='col') {{ $tc("m.BT_OE", 2) }}
              tbody
                tr(v-for="(item, key, index) in schedule.EFResult")
                  td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                  td(:data-label="$t('ui.team')")
                    .digits.rounded-circle.mx-auto.text-white.bg-warning(v-if="item.team_1 == 1 || item.team_4 == 1 || item.team_7 == 1 || item.team_10 == 1") A
                    .digits.rounded-circle.mx-auto.text-white.bg-secondary(v-if="item.team_2 == 1 || item.team_5 == 1 || item.team_8 == 1 || item.team_11 == 1") B
                    .digits.rounded-circle.mx-auto.text-white.bg-info(v-if="item.team_3 == 1 || item.team_6 == 1 || item.team_9 == 1 || item.team_12 == 1") C
                  td(:data-label="$t('ui.winner')")
                    span(v-if="item.team_1 == 1") {{ item.team_1_name }}
                    span(v-if="item.team_2 == 1") {{ item.team_2_name }}
                    span(v-if="item.team_3 == 1") {{ item.team_3_name }}
                    span(v-if="item.team_4 == 1") {{ item.team_4_name }}
                    span(v-if="item.team_5 == 1") {{ item.team_5_name }}
                    span(v-if="item.team_6 == 1") {{ item.team_6_name }}
                    span(v-if="item.team_7 == 1") {{ item.team_7_name }}
                    span(v-if="item.team_8 == 1") {{ item.team_8_name }}
                    span(v-if="item.team_9 == 1") {{ item.team_9_name }}
                    span(v-if="item.team_10 == 1") {{ item.team_10_name }}
                    span(v-if="item.team_11 == 1") {{ item.team_11_name }}
                    span(v-if="item.team_12 == 1") {{ item.team_12_name }}
                  td(:data-label='$tc("m.BT_OU", 2)')
                    .digits.rounded-circle.mx-auto.text-white.bg-danger(v-if="item.team_7 == 1 || item.team_8 == 1 || item.team_9 == 1 || item.team_10 == 1 || item.team_11 == 1 || item.team_12 == 1") {{ $t('m.LOT_OVER') }}
                    .digits.rounded-circle.mx-auto.text-white.bg-primary(v-else) {{ $t('m.LOT_UNDER') }}
                  td(:data-label='$tc("m.BT_OE", 2)')
                    .digits.rounded-circle.mx-auto.text-white.bg-danger(v-if="item.team_1 == 1 || item.team_3 == 1 || item.team_5 == 1 || item.team_7 == 1 || item.team_9 == 1 || item.team_11 == 1") {{ $t('m.LOT_ODD') }}
                    .digits.rounded-circle.mx-auto.text-white.bg-primary(v-else) {{ $t('m.LOT_EVEN') }}
        .tab-content(v-else-if="[44,43,42,41,47,52,53].includes(parseInt(sportsType))")
          table
            thead
              tr.text-white.result-bg
                th(scope='col' style="width:20%;") {{ $t('ui.date') }}
                th(scope='col') {{ $t('ui.match') }}
                th(scope='col' style="width:10%;") {{ $t('ui.score') }}
                th(scope='col' style="width:10%;") {{ $t('ui.winner') }}
                template(v-if="![41,47,52,53].includes(parseInt(sportsType))")
                  th(scope='col' style="width:10%;" v-if="[42].includes(parseInt(sportsType))") {{ $t('ui.ko') }}
                  th(scope='col' style="width:10%;" v-else) {{ $tc("m.BT_OU", 1) }}
            tbody
              tr(v-for="(item, key, index) in schedule.EFResult")
                td(:data-label="$t('ui.date')") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
                td(:data-label="$t('ui.match')") {{ item.home_name_en }} -vs- {{ item.away_name_en }}
                td(:data-label="$t('ui.score')") {{ item.score }}
                td(:data-label="$t('ui.winner')") 
                  .digits.rounded-circle.text-white(:class="item.home_win == 1 ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.home_win) }}
                template(v-if="![41,47,52,53].includes(parseInt(sportsType))")
                  template(v-if="[42].includes(parseInt(sportsType))")
                    td(:data-label="$t('ui.ko')")
                      .digits.rounded-circle.text-white(:class="item.over_under == 'odd' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}
                  template(v-else)
                    td(:data-label="$tc('m.BT_OU', 1)")
                      .digits.rounded-circle.text-white(:class="item.over_under == 'over' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}
        .tab-content(v-else)
          table.table.table-bordered.text-center.table-digits(style="width: 90%; min-width: 900px;")
            tr.bg-color01.text-white
              //- have to change to multilanguage
              th(width="150px" style="text-align: left; vertical-align: middle")  {{ $t('ui.date') }}
              th(style="text-align: left; vertical-align: middle")  {{ $t('ui.match') }}
              th(width="120px" style="vertical-align: middle")  {{ $t('ui.score') }}
              th(width="120px" style="vertical-align: middle")  {{ $t('ui.winner') }}
              template(v-if="![41,47].includes(parseInt(sportsType))")
                th(width="120px" style="vertical-align: middle" v-if="[42].includes(parseInt(sportsType))")  {{ $t('ui.ko') }}
                th(width="120px" style="vertical-align: middle" v-else)  {{ $tc("m.BT_OU", 1) }}
            tr.bg-color03(v-for="(item, key, index) in schedule.EFResult")
              td(style="text-align: left; vertical-align: middle") {{ $dayjs(item.match_time).format("MM/DD/YYYY h:mm A") }}
              td(style="text-align: left; vertical-align: middle") {{ item.home_name_en }} -vs- {{ item.away_name_en }}
              td(style="vertical-align: middle") {{ item.score }}
              td(style="vertical-align: middle")
                .digits.rounded-circle.mx-auto.text-white(:class="item.home_win == 1 ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.home_win) }}
              template(v-if="![41,47].includes(parseInt(sportsType))")
                td(style="vertical-align: middle")
                  .digits.rounded-circle.mx-auto.text-white(v-if="[42].includes(parseInt(sportsType))" :class="item.over_under == 'odd' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}
                  .digits.rounded-circle.mx-auto.text-white(v-else :class="item.over_under == 'over' ? 'bg-danger' : 'bg-primary'") {{ $t('m.LOT_'+item.over_under.toUpperCase()) }}

</template>
  
<script>
import config from "@/config";
import errors from "@/errors";
import SpinButton from "@/components/ui/SpinButton";
import mixinExt from "@/library/mixinExt.js";

export default {
  components: {
    SpinButton
  },
  mixins: [mixinExt],
  data() {
    return {
      sportsType: null,
      title: "",
      url: "",
      img: "",
      domain: "",
      tabs: 0,
      result: []
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    racingList1() {
      return config.racingList1;
    },
    racingList2() {
      return config.racingList2;
    },
    racingList3() {
      return config.racingList3;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    var q = this.$route.query;
    // console.log(q);

    if (q.q) {
      this.sportsType = q.q;
      this.title = q.n.replace("$", "+");
      // this.url = q.u;
      // this.domain = this.extractDomain(q.u);
      setTimeout(() => {
        this.query();
      }, 500);
    }
  },
  methods: {
    getTab(e) {
      return config.sports4dTab[100 + e];
    },
    extractDomain(url) {
      var domain;
      //find & remove protocol (http, ftp, etc.) and get domain
      if (url.indexOf("://") > -1) {
        domain = url.split("/")[2];
      } else {
        domain = url.split("/")[0];
      }

      //find & remove www
      if (domain.indexOf("www.") > -1) {
        domain = domain.split("www.")[1];
      }

      domain = domain.split(":")[0]; //find & remove port number
      domain = domain.split("?")[0]; //find & remove url params

      return domain;
    },
    query() {
      // this function is in mixinExt.js
      this.getEFResult(this.sportsType).then(() => {
        // console.log(this.schedule);
      });
    },
    getImage(e) {
      return config.getSportsImage(e);
    }
  }
};
</script>

<style>
table {
  border: 1px solid #ccc;
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}

table caption {
  font-size: 1.5em;
  margin: .5em 0 .75em;
}

table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: .35em;
}

table th,
table td {
  padding: .625em;
  text-align: center;
}

table th {
  font-size: .85em;
  letter-spacing: .1em;
  text-transform: uppercase;
  /* background-color: #0d3a64; */
  /* background-image: url(/images/egame/header-bg.jpg);
  background-size: cover; */
}

.result-bg {
  background-image: url(/images/egame/header-bg.jpg); /* Replace with your image URL */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #000 !important; /* Adjust text color for better visibility */
}

@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }
  
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  
  table tr {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
  }
  
  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;
  }
  
  .digits {
    margin-right: unset !important;
  }
  
  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  
  table td:last-child {
    border-bottom: 0;
  }  
}
</style>
  